import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getCachedScript } from "../../utils/scriptCache.js";
import "./AutoColorsScheme.css";

function AutoColorsScheme({
  isVisible,
  setIsVisible,
  useCepStorage,
  saveCepStorage,
  getCepStorage,
  optionsPath,
  selectedTag,
  buttonTags,
  generateButtonTags,
  button,
}) {
  const ADD_CONTROL_LAYER = `${optionsPath}.addControlLayer`;
  const ADD_EXPRESSION = `${optionsPath}.addExpression`;
  const SKIP_SHAPE_COLOR = `${optionsPath}.skipShapeColor`;
  const CONTROL_LAYER_ID = `${optionsPath}.controlLayerID`;
  const CONTROL_LAYER_COMP_NAME = `${optionsPath}.controlLayerCompName`;
  const SEPARATE_LAYERS_COLORS = `${optionsPath}.separateLayersColors`;
  const OPTIMIZE_CONTROLS = `${optionsPath}.optimizeControls`;
  const IGNORE_PROPERTIES = `${optionsPath}.ignoreProperties`;

  const BASE_PROPERTIES = [
    { name: "Shape Fill", matchName: "ADBE Vector Fill Color", enabled: true },
    {
      name: "Shape Stroke",
      matchName: "ADBE Vector Stroke Color",
      enabled: true,
    },
    { name: "Text Document Fill", matchName: "fillColor", enabled: true },
    { name: "Text Animator Fill", matchName: "ADBE Text Fill Color", enabled: true },
    { name: "Text Animator Stroke", matchName: "ADBE Text Stroke Color", enabled: true },
    { name: "CC Blobbylize", matchName: "CC Blobbylize", enabled: true },
    {
      name: "CC Color Neutralizer",
      matchName: "CS Color Neutralizer",
      enabled: true,
    },
    { name: "CC Cylinder", matchName: "CC Cylinder", enabled: true },
    { name: "CC Drizzle", matchName: "CC Drizzle", enabled: true },
    { name: "CC Glass", matchName: "CC Glass", enabled: true },
    { name: "CC Glue Gun", matchName: "CC Glue Gun", enabled: true },
    { name: "CC Hair", matchName: "CC Hair", enabled: true },
    {
      name: "CC Light Burst 2.5",
      matchName: "CC Light Burst 2.5",
      enabled: true,
    },
    { name: "CC Light Rays", matchName: "CC Light Rays", enabled: true },
    { name: "CC Light Sweep", matchName: "CC Light Sweep", enabled: true },
    { name: "CC Light Wipe", matchName: "CC Light Wipe", enabled: true },
    { name: "CC Mr. Mercury", matchName: "CC Mr. Mercury", enabled: true },
    { name: "CC Overbrights", matchName: "CC Overbrights", enabled: true },
    { name: "CC Page Turn", matchName: "CC Page Turn", enabled: true },
    {
      name: "CC PS Classic (obsolete)",
      matchName: "CC PS Classic",
      enabled: true,
    },
    {
      name: "CC Particle Systems II",
      matchName: "CC Particle Systems II",
      enabled: true,
    },
    {
      name: "CC PS LE Classic (obsolete)",
      matchName: "CC PS LE Classic",
      enabled: true,
    },
    { name: "CC Plastic", matchName: "CC Plastic", enabled: true },
    {
      name: "CC Particle World",
      matchName: "CC Particle World",
      enabled: true,
    },
    { name: "CC Rainfall", matchName: "CSRainfall", enabled: true },
    { name: "CC Slant", matchName: "CC Slant", enabled: true },
    { name: "CC Snowfall", matchName: "CSSnowfall", enabled: true },
    { name: "CC Sphere", matchName: "CC Sphere", enabled: true },
    { name: "CC Spotlight", matchName: "CC Spotlight", enabled: true },
    { name: "CC Toner", matchName: "CC Toner", enabled: true },
    { name: "Keylight (1.2)", matchName: "Keylight 906", enabled: true },
    { name: "mocha shape", matchName: "ISL MochaShapeImporter", enabled: true },
    {
      name: "Mask Prompter 3",
      matchName: "ADBE Mask Prompter 3",
      enabled: true,
    },
    { name: "Add Grain", matchName: "VISINF Grain Implant", enabled: true },
    { name: "Audio Spectrum", matchName: "ADBE AudSpect", enabled: true },
    { name: "Audio Waveform", matchName: "ADBE AudWave", enabled: true },
    { name: "Beam", matchName: "ADBE Laser", enabled: true },
    { name: "Bevel Alpha", matchName: "ADBE Bevel Alpha", enabled: true },
    { name: "Bevel Edges", matchName: "ADBE Bevel Edges", enabled: true },
    { name: "Card Dance", matchName: "APC CardDanceCam", enabled: true },
    { name: "Card Wipe", matchName: "APC CardWipeCam", enabled: true },
    { name: "Caustics", matchName: "APC Caustics", enabled: true },
    {
      name: "Change to Color",
      matchName: "ADBE Change To Color",
      enabled: true,
    },
    { name: "Change Color", matchName: "ADBE Change Color", enabled: true },
    { name: "Checkerboard", matchName: "ADBE Checkerboard", enabled: true },
    { name: "Circle", matchName: "ADBE Circle", enabled: true },
    { name: "Colorama", matchName: "APC Colorama", enabled: true },
    {
      name: "4-Color Gradient",
      matchName: "ADBE 4ColorGradient",
      enabled: true,
    },
    {
      name: "Color Difference Key",
      matchName: "ADBE Color Difference Key",
      enabled: true,
    },
    { name: "Color Key", matchName: "ADBE Color Key", enabled: true },
    { name: "Drop Shadow", matchName: "ADBE Drop Shadow", enabled: true },
    { name: "Ellipse", matchName: "ADBE ELLIPSE", enabled: true },
    { name: "Fill", matchName: "ADBE Fill", enabled: true },
    { name: "Fog 3D", matchName: "ADBE FOG_3D", enabled: true },
    { name: "Glow", matchName: "ADBE Glo2", enabled: true },
    { name: "Grid", matchName: "ADBE Grid", enabled: true },
    { name: "Leave Color", matchName: "ADBE Leave Color", enabled: true },
    { name: "Lightning", matchName: "ADBE Lightning", enabled: true },
    {
      name: "Advanced Lightning",
      matchName: "ADBE Lightning 2",
      enabled: true,
    },
    {
      name: "Linear Color Key",
      matchName: "ADBE Linear Color Key2",
      enabled: true,
    },
    { name: "Lumetri Color", matchName: "ADBE Lumetri", enabled: true },
    {
      name: "Match Grain",
      matchName: "VISINF Grain Duplication",
      enabled: true,
    },
    { name: "Paint Bucket", matchName: "ADBE Paint Bucket", enabled: true },
    { name: "Particle Playground", matchName: "ADBE Playgnd", enabled: true },
    { name: "Photo Filter", matchName: "ADBE Photo Filter", enabled: true },
    { name: "Photo Filter", matchName: "ADBE PhotoFilterPS", enabled: true },
    { name: "Black & White", matchName: "ADBE Black&White", enabled: true },
    {
      name: "Photoshop Bevel And Emboss",
      matchName: "ADBE PSL Bevel Emboss",
      enabled: true,
    },
    {
      name: "Photoshop Drop Shadow",
      matchName: "ADBE PSL Drop Shadow",
      enabled: true,
    },
    {
      name: "Photoshop Inner Glow",
      matchName: "ADBE PSL Inner Glow",
      enabled: true,
    },
    {
      name: "Photoshop Inner Shadow",
      matchName: "ADBE PSL Inner Shadow",
      enabled: true,
    },
    {
      name: "Photoshop Outer Glow",
      matchName: "ADBE PSL Outer Glow",
      enabled: true,
    },
    {
      name: "Photoshop Solid Fill",
      matchName: "ADBE PSL Solid Fill",
      enabled: true,
    },
    { name: "Radial Shadow", matchName: "ADBE Radial Shadow", enabled: true },
    { name: "Radio Waves", matchName: "APC Radio Waves", enabled: true },
    { name: "Gradient Ramp", matchName: "ADBE Ramp", enabled: true },
    { name: "Remove Grain", matchName: "VISINF Grain Removal", enabled: true },
    { name: "Roughen Edges", matchName: "ADBE Roughen Edges", enabled: true },
    { name: "Scribble", matchName: "ADBE Scribble Fill", enabled: true },
    { name: "Shatter", matchName: "APC Shatter", enabled: true },
    {
      name: "Solid Composite",
      matchName: "ADBE Solid Composite",
      enabled: true,
    },
    {
      name: "Spill Suppressor",
      matchName: "ADBE Spill Suppressor",
      enabled: true,
    },
    {
      name: "Advanced Spill Suppressor",
      matchName: "ADBE Spill2",
      enabled: true,
    },
    { name: "Strobe Light", matchName: "ADBE Strobe", enabled: true },
    { name: "Stroke", matchName: "ADBE Stroke", enabled: true },
    {
      name: "Three-Way Color Corrector",
      matchName: "ADBE Three-Way Color Corrector",
      enabled: true,
    },
    { name: "Timecode", matchName: "ADBE Timecode", enabled: true },
    { name: "Tint", matchName: "ADBE Tint", enabled: true },
    { name: "Tritone", matchName: "ADBE Tritone", enabled: true },
    {
      name: "Remove Color Matting",
      matchName: "ADBE Remove Color Matting",
      enabled: true,
    },
    { name: "Vegas", matchName: "APC Vegas", enabled: true },
    {
      name: "Video Limiter",
      matchName: "ADBE DigitalVideoLimiter",
      enabled: true,
    },
    {
      name: "VR Color Gradients",
      matchName: "Mettle SkyBox Color Gradients",
      enabled: true,
    },
    { name: "VR Glow", matchName: "Mettle SkyBox Glow", enabled: true },
    { name: "Write-on", matchName: "ADBE Write-on", enabled: true },
    { name: "Color Swirl", matchName: "ADBE Color Swirl", enabled: true },
    { name: "Getting Jiggy", matchName: "ADBE Getting Jiggy", enabled: true },
    {
      name: "Inset Video - framed",
      matchName: "ADBE CM InsetVideoFramed",
      enabled: true,
    },
    { name: "Fly to Inset", matchName: "ADBE CM FlyToInset", enabled: true },
    {
      name: "Random Fill Color",
      matchName: "ADBE DE Random Fill Color",
      enabled: true,
    },
    { name: "Sample Image", matchName: "ADBE Sample Image", enabled: true },
  ];

  const [controlLayer, setControlLayer] = useCepStorage(ADD_CONTROL_LAYER);
  const [expression, setExpression] = useCepStorage(ADD_EXPRESSION);
  const [skipShape, setSkipShape] = useCepStorage(SKIP_SHAPE_COLOR);
  const [layerID, setLayerID] = useCepStorage(CONTROL_LAYER_ID);
  const [compName, setCompName] = useCepStorage(CONTROL_LAYER_COMP_NAME);
  const [separateForLayers, setSeparateForLayers] = useCepStorage(
    SEPARATE_LAYERS_COLORS,
  );
  const [optimizeControls, setOptimizeControls] =
    useCepStorage(OPTIMIZE_CONTROLS);

  const [ignoreProperties, setIgnoreProperties] = useCepStorage(
    IGNORE_PROPERTIES,
    [],
  );
  const [isEffectsPopupOpen, setIsEffectsPopupOpen] = useState(false);
  const [effectsSearch, setEffectsSearch] = useState("");
  const [hasInitializedIgnoreProps, setHasInitializedIgnoreProps] =
    useState(false);

  const handleClick = (script, argument) => {
    const code = getCachedScript();
    if (code) {
      window.jsx.evalScript(`run(${script}(${argument}));`, function (result) {
        if (result && result !== "undefined" && script === "$.ae.layerID") {
          result = result === "false" ? (result = false) : JSON.parse(result);
          setLayerID(result.id);
          setCompName(result.name);
        }
      });
    }
  };

  useEffect(() => {
    if (layerID) {
      setControlLayer(false);
    }
  }, [layerID]);

  useEffect(() => {
    if (controlLayer) {
      setLayerID(false);
    }
  }, [controlLayer]);

  useEffect(() => {
    if (hasInitializedIgnoreProps) {
      return;
    }

    if (!Array.isArray(ignoreProperties) || ignoreProperties.length === 0) {
      setIgnoreProperties(BASE_PROPERTIES);
      setHasInitializedIgnoreProps(true);
      return;
    }

    const savedByMatchName = new Map(
      ignoreProperties.map((property) => [property.matchName, property]),
    );
    const baseMatchNames = new Set(
      BASE_PROPERTIES.map((property) => property.matchName),
    );
    const extraProperties = ignoreProperties.filter(
      (property) => property && !baseMatchNames.has(property.matchName),
    );

    const normalizedProperties = [
      ...BASE_PROPERTIES.map((baseProperty) => {
        const savedProperty = savedByMatchName.get(baseProperty.matchName);

        if (!savedProperty) {
          return { ...baseProperty, enabled: false };
        }

        return {
          ...baseProperty,
          enabled:
            typeof savedProperty.enabled === "boolean"
              ? savedProperty.enabled
              : baseProperty.enabled,
        };
      }),
      ...extraProperties,
    ];

    const hasOrderOrValueChanges =
      normalizedProperties.length !== ignoreProperties.length ||
      normalizedProperties.some((property, index) => {
        const currentProperty = ignoreProperties[index];

        return (
          !currentProperty ||
          currentProperty.matchName !== property.matchName ||
          currentProperty.enabled !== property.enabled ||
          currentProperty.name !== property.name
        );
      });

    if (hasOrderOrValueChanges) {
      setIgnoreProperties(normalizedProperties);
    }

    setHasInitializedIgnoreProps(true);
  }, [hasInitializedIgnoreProps, ignoreProperties, setIgnoreProperties]);

  const disabledIgnoreProperties = React.useMemo(() => {
    if (!Array.isArray(ignoreProperties)) {
      return [];
    }

    return ignoreProperties
      .filter((property) => property && property.enabled === false)
      .map((property) => property.matchName);
  }, [ignoreProperties]);

  const effectsList =
    Array.isArray(ignoreProperties) && ignoreProperties.length > 0
      ? ignoreProperties
      : BASE_PROPERTIES;

  const filteredEffects = React.useMemo(() => {
    const query = effectsSearch.trim().toLowerCase();
    if (!query) {
      return effectsList;
    }

    return effectsList.filter((effect) => {
      const name = effect?.name?.toLowerCase() || "";

      return name.includes(query);
    });
  }, [effectsList, effectsSearch]);

  const toggleAllEffects = (enabled) => {
    setIgnoreProperties((prev = []) => {
      const source =
        Array.isArray(prev) && prev.length > 0 ? prev : BASE_PROPERTIES;

      return source.map((effect) => ({ ...effect, enabled }));
    });
  };

  const handleSelectAll = () => toggleAllEffects(true);
  const handleDisableAll = () => toggleAllEffects(false);

  const handleEffectToggle = (matchName) => {
    setIgnoreProperties((prev = []) => {
      const source =
        Array.isArray(prev) && prev.length > 0 ? prev : BASE_PROPERTIES;

      return source.map((effect) => {
        if (effect.matchName === matchName) {
          return { ...effect, enabled: !effect.enabled };
        }

        return { ...effect };
      });
    });
  };

  const closeEffectsPopup = () => setIsEffectsPopupOpen(false);
  useEffect(() => {
    const { body } = document;
    if (!body) {
      return;
    }

    const originalOverflow = body.style.overflow;

    if (isEffectsPopupOpen) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "";
    }

    return () => {
      body.style.overflow = originalOverflow;
    };
  }, [isEffectsPopupOpen]);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <div dangerouslySetInnerHTML={{ __html: button.icon }} />
        </div>
        <div className="button-card__title">{button.name}</div>
        {generateButtonTags()}
      </li>
      {!isEffectsPopupOpen && (
        <div
          className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
        >
          <div className="render-group__checkbox-group">
            <div
              className={`render-group__checkbox ${layerID ? "hidden" : ""}`}
            >
              <input
                type="checkbox"
                id="autoColorsSchemeControlLayer"
                checked={controlLayer}
                onChange={() => setControlLayer(!controlLayer)}
                className="hidden-checkbox"
              />
              <label htmlFor="autoColorsSchemeControlLayer">
                <span className="custom-checkbox"></span>
                <span className="label-text">Add Control Layer</span>
              </label>
            </div>
            <div className="render-group__checkbox">
              <input
                type="checkbox"
                id="autoColorsSchemeExpression"
                checked={expression}
                onChange={() => setExpression(!expression)}
                className="hidden-checkbox"
              />
              <label htmlFor="autoColorsSchemeExpression">
                <span className="custom-checkbox"></span>
                <span className="label-text">Add Expression</span>
              </label>
            </div>
            <div className="render-group__checkbox">
              <input
                type="checkbox"
                id="auto-colors-scheme-separate-layers"
                checked={separateForLayers}
                onChange={() => setSeparateForLayers(!separateForLayers)}
                className="hidden-checkbox"
              />
              <label htmlFor="auto-colors-scheme-separate-layers">
                <span className="custom-checkbox"></span>
                <span className="label-text">Separate for Layers</span>
              </label>
            </div>
            <div className="render-group__checkbox">
              <input
                type="checkbox"
                id="auto-colors-scheme-optimize-controls"
                checked={optimizeControls}
                onChange={() => setOptimizeControls(!optimizeControls)}
                className="hidden-checkbox"
              />
              <label htmlFor="auto-colors-scheme-optimize-controls">
                <span className="custom-checkbox"></span>
                <span className="label-text">Optimize Controls</span>
              </label>
            </div>
          </div>

          <div className="set-button">
            <div
              onClick={() => setIsEffectsPopupOpen(true)}
              className="render-group__button"
            >
              <i className="fa-solid fa-wand-magic-sparkles"></i>
              <span className="render-group__button-text">Find Effects</span>
            </div>
          </div>

          <div className={`set-button ${controlLayer ? "hidden" : ""}`}>
            <div
              onClick={() => handleClick("$.ae.layerID", false)}
              className={`render-group__button ${
                layerID ? "set-button-active exp" : ""
              }`}
            >
              {layerID ? (
                <div>{compName}</div>
              ) : (
                <>
                  <i className="fa-regular fa-circle-a"></i>
                  <span className="render-group__button-text">
                    Set Control Layer
                  </span>
                </>
              )}
            </div>
          </div>

          <div className="videobolt-tools">
            <div
              onClick={() =>
                handleClick(
                  "autoColorsScheme",
                  JSON.stringify({
                    type: "layer",
                    controlLayer: controlLayer,
                    expression: expression,
                    skipShape: skipShape,
                    notification: true,
                    layerID: layerID,
                    separateForLayers: separateForLayers,
                    optimizeControls: optimizeControls,
                    ignoreProperties: disabledIgnoreProperties,
                  }),
                )
              }
              className="resolution-tools__button"
            >
              <i class="fa-light fa-layer-group"></i>
              <span>Selected Layers</span>
            </div>

            <div
              onClick={() =>
                handleClick(
                  "autoColorsScheme",
                  JSON.stringify({
                    type: "comp",
                    controlLayer: controlLayer,
                    expression: expression,
                    skipShape: skipShape,
                    notification: true,
                    layerID: layerID,
                    separateForLayers: separateForLayers,
                    optimizeControls: optimizeControls,
                    ignoreProperties: disabledIgnoreProperties,
                  }),
                )
              }
              className="resolution-tools__button"
            >
              <i class="fa-solid fa-image-polaroid"></i>
              <span>Active Comp</span>
            </div>

            <div
              onClick={() =>
                handleClick(
                  "autoColorsScheme",
                  JSON.stringify({
                    type: "selected comp",
                    controlLayer: controlLayer,
                    expression: expression,
                    skipShape: skipShape,
                    notification: true,
                    layerID: layerID,
                    separateForLayers: separateForLayers,
                    optimizeControls: optimizeControls,
                    ignoreProperties: disabledIgnoreProperties,
                  }),
                )
              }
              className="resolution-tools__button"
            >
              <i class="fa-solid fa-images"></i>
              <span>Selected Comp</span>
            </div>

            <div
              onClick={() =>
                handleClick(
                  "autoColorsScheme",
                  JSON.stringify({
                    type: "project",
                    controlLayer: controlLayer,
                    expression: expression,
                    skipShape: skipShape,
                    notification: true,
                    layerID: layerID,
                    ignoreProperties: disabledIgnoreProperties,
                  }),
                )
              }
              className={`${
                separateForLayers ? "hidden" : "resolution-tools__button"
              }`}
            >
              <i class="fa-solid fa-images"></i>
              <span>Project</span>
            </div>
          </div>
        </div>
      )}
      {isEffectsPopupOpen &&
        createPortal(
          <div className="effects-popup-overlay" onClick={closeEffectsPopup}>
            <div
              className="effects-popup"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="effects-popup__header">
                <span>Effects</span>
                <button
                  type="button"
                  className="effects-popup__close"
                  onClick={closeEffectsPopup}
                >
                  Close
                </button>
              </div>
              <div className="effects-popup__actions">
                <button
                  type="button"
                  className="effects-popup__action"
                  onClick={handleSelectAll}
                >
                  Select All
                </button>
                <button
                  type="button"
                  className="effects-popup__action"
                  onClick={handleDisableAll}
                >
                  Disable All
                </button>
              </div>
              <div className="effects-popup__search-wrapper">
                <div className="effects-popup__search-box">
                  <input
                    type="text"
                    className="effects-popup__search"
                    placeholder="Search effects..."
                    value={effectsSearch}
                    onChange={(event) => setEffectsSearch(event.target.value)}
                  />
                </div>
              </div>
              <div className="effects-popup__list">
                {filteredEffects.length === 0 && (
                  <div className="effects-popup__empty">
                    No effects match your search.
                  </div>
                )}
                {filteredEffects.map((effect) => (
                  <label
                    key={effect.matchName}
                    className={`effects-popup__item ${
                      effect.enabled ? "" : "effects-popup__item--disabled"
                    }`}
                  >
                    <input
                      type="checkbox"
                      className="hidden-checkbox"
                      checked={!!effect.enabled}
                      onChange={() => handleEffectToggle(effect.matchName)}
                    />
                    <span className="custom-checkbox" aria-hidden="true"></span>
                    <span className="effects-popup__item-name">
                      {effect.name}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}

export default AutoColorsScheme;
